// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__39_zy","mainImage":"Gallery_mainImage__2BH98","thumbnails":"Gallery_thumbnails__2eydr"};